module.exports = __webpack_public_path__ + "img/38_27.13b93800.png";